<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
:root {
  --app-height: 100vh;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  min-height: 100%;
}

#app {
  min-height: var(--app-height);
}

body {
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}
ul,
li {
  list-style-type: none;
}
a {
  text-decoration: none;
  color: black;
}
input {
  outline: none;
}
.ivu-tabs-nav{
  line-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue